import { render, staticRenderFns } from "./newdeviceControl.vue?vue&type=template&id=06f09c42&scoped=true&"
import script from "./newdeviceControl.vue?vue&type=script&lang=js&"
export * from "./newdeviceControl.vue?vue&type=script&lang=js&"
import style0 from "./newdeviceControl.vue?vue&type=style&index=0&id=06f09c42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f09c42",
  null
  
)

export default component.exports